var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_logout",
    "data-name": "vuesax/bold/logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.325,0H6.492a4.027,4.027,0,0,1,4.333,4.333V7.708H5.617a.625.625,0,0,0,0,1.25h5.208v3.375a4.027,4.027,0,0,1-4.333,4.333H4.333A4.027,4.027,0,0,1,0,12.333v-8A4.016,4.016,0,0,1,4.325,0Z",
    transform: "translate(1.675 1.667)",
    fill: "#030014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.7,2.79,1.975,1.065A.618.618,0,0,1,1.792.623.6.6,0,0,1,1.975.181a.629.629,0,0,1,.883,0L5.65,2.973a.629.629,0,0,1,0,.883L2.858,6.648a.625.625,0,0,1-.883-.883L3.7,4.04H0V2.79Z",
    transform: "translate(12.5 6.585)",
    fill: "#030014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,20H20V0H0Z",
    transform: "translate(0 0)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.32c1bc0aeb5d0f0ba7dce7dbcdb228c2.svg";
export { ForwardRef as ReactComponent };